import { MediaStreamTypes } from "@videojs/media";
//#region src/stream-type.ts
function ShakaStreamTypeMixin(BaseClass) {
	class ShakaStreamType extends BaseClass {
		#streamType = MediaStreamTypes.UNKNOWN;
		#isUserStreamType = false;
		constructor(...args) {
			super(...args);
			const { engine } = this;
			if (!engine) return;
			engine.addEventListener("loading", this.#forget);
			engine.addEventListener("unloading", this.#forget);
			engine.addEventListener("manifestparsed", this.#detect);
			engine.addEventListener("manifestupdated", this.#detect);
			engine.addEventListener("loaded", this.#detect);
		}
		destroy() {
			const { engine } = this;
			engine?.removeEventListener("loading", this.#forget);
			engine?.removeEventListener("unloading", this.#forget);
			engine?.removeEventListener("manifestparsed", this.#detect);
			engine?.removeEventListener("manifestupdated", this.#detect);
			engine?.removeEventListener("loaded", this.#detect);
			super.destroy();
		}
		get streamType() {
			return this.#streamType;
		}
		set streamType(value) {
			if (value === MediaStreamTypes.UNKNOWN) {
				this.#isUserStreamType = false;
				this.#update(MediaStreamTypes.UNKNOWN);
				return;
			}
			this.#isUserStreamType = true;
			this.#update(value);
		}
		#forget = () => this.#setDetected(MediaStreamTypes.UNKNOWN);
		#detect = () => {
			const { engine } = this;
			if (!engine) return;
			const live = engine.isLive() || engine.isInProgress();
			this.#setDetected(live ? MediaStreamTypes.LIVE : MediaStreamTypes.ON_DEMAND);
		};
		#setDetected(value) {
			if (this.#isUserStreamType) return;
			this.#update(value);
		}
		#update(value) {
			if (this.#streamType === value) return;
			this.#streamType = value;
			this.dispatchEvent(new Event("streamtypechange"));
		}
	}
	return ShakaStreamType;
}
//#endregion
export { ShakaStreamTypeMixin };
